import { render, staticRenderFns } from "./CustomerDrawer.vue?vue&type=template&id=594ddaf7&scoped=true"
import script from "./CustomerDrawer.vue?vue&type=script&lang=js"
export * from "./CustomerDrawer.vue?vue&type=script&lang=js"
import style0 from "./CustomerDrawer.vue?vue&type=style&index=0&id=594ddaf7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594ddaf7",
  null
  
)

export default component.exports